import { makeStyles } from "@inductiveautomation/ws-components";

export const getHubspotEmailPreferencesStyles = makeStyles()(() => ({
  // Stacks the (optional) error alert above the Manage row with an 8px gap.
  // gap only takes effect when both are present, so the row sits flush when the
  // alert is hidden.
  marketingSection: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
}));
